<div *ngIf="!showAlertAnalyze">
    <div class="statelist-wrapper">
        <div class="make-responsive-statelist">
            <div class="statewidget" *ngFor="let state of alertStatus">
                <div 
                    class="mainbox cursor" 
                    [class.selected]="statusFilter === state.category" 
                    style="--state-bg:{{ state?.countBgColor}};"
                    (click)="handleStatusClick(state.category)">
                    <div class="state-left" 
                         [style.background-color]="statusFilter === state.category ? state?.countSelectedBgColor : state?.countBgColor">
                        <div class="state-left-text" 
                             [style.color]="statusFilter === state.category ? state?.fontSelectedColor : state?.fontColor">
                            {{ state?.count ?? 0 }}
                        </div>
                    </div>
                    <div class="state-right" [class.selected]="statusFilter === state.category" style="--state-bg:{{ state?.countBgColor}};">
                        <div class="state-right-text">
                            {{ state?.name ?? '-' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="make-responsive-statelist">
            <div class="statewidget" *ngFor="let state of alertSeverity">
                <div 
                    class="mainbox cursor" 
                    [class.selected]="severityFilter === state.category" 
                    style="--state-bg:{{ state?.countBgColor}};"
                    (click)="handleSeverityClick(state.category)">
                    <div class="state-left" 
                         [style.background-color]="(severityFilter === state.category ? state?.countSelectedBgColor : state?.countBgColor)">
                        <div class="state-left-text" 
                             [style.color]="severityFilter === state.category ? state?.fontSelectedColor : state?.fontColor">
                            {{ state?.count ?? 0 }}
                        </div>
                    </div>
                    <div class="state-right" [class.selected]="severityFilter === state.category" style="--state-bg:{{ state?.countBgColor}};">
                        <div class="state-right-text">
                            {{ state?.name ?? '-' }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-common-table [tableData]="alertsMaster" [columnHeader]="columnHeader" [pageType]="'alerts'" [showMultiSelect]="columnHeader?.multiSelect"
    class="app-common-table" [actionPermission]="{view:false,edit:false,delete:false,download:false,alert:true,acknowledge:true, pagination:false,
      createIncident:_sharedService.rbacManagement('events_alerts_incidents')?true: false, downloadCase: _sharedService.rbacManagement('events_alerts_Downloaddata')?true: false, eventsDrilldown : _sharedService.rbacManagement('events_alerts_EventsDrillDown')}"
    (tableAction)="tableAction($event)" (pageSizeChange)="onPageSizeChange($event)">
    </app-common-table>
    <app-standard-pagination [pagination]="pager" backgroundColor="'#f8f8f8'"
    *ngIf="pager && pager?.pages?.length > 1" (paginationAction)="onPaginateChange($event)">
    </app-standard-pagination>
</div>


<div *ngIf="showAlertAnalyze">
    <app-alert-analyze [alertDetails]="alertAnalyzeDetails" [pageType]="'case'" [fromDate]="fromDate" [toDate]="toDate"></app-alert-analyze>
  </div>